import { renameProperty } from '../rename-property';

export const renameSsnToPerson = renameProperty(
  'socialSecurityNumber',
  'person',
);

export const renamePersonToSsn = renameProperty(
  'person',
  'socialSecurityNumber',
);
